const initialState = {
  language: localStorage.getItem("language") ?? "az",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_LANGUAGE":
      return {
        ...state,
        language: action.payload.value,
      };

    default:
      return state;
  }
}
